import styled from 'styled-components';
// eslint-disable-next-line import/prefer-default-export
export const Content = styled.section`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
